/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 17/12/2022
 */
import BaseObject from "@shared/BaseObject.js";
import {uuidv4} from "@/utils/helpers";

export default class PartialPaymentsSettings extends BaseObject {

	id: string = uuidv4()
	isEnabled: boolean = false
	savingsAmount: number = 0
	installmentsTotal: number = 3
	extraFee: number = 0
	repeatInterval: number = 1
	intervalLength: string = "month"
	payments: number[] = []

	constructor() {
		super();
	}

	splitEqually(price){
		price += this.extraFee
		let installments = Math.max(1, Math.min(this.installmentsTotal, 50))
		let amount = Math.ceil(price / installments * 100) / 100
		let array = []
		for(let i = 0; i < installments; i++){
			array.push(amount)
		}
		this.payments = array
	}

	singlePaymentAmount(){
		if(this.payments.length > 0){
			return this.payments[0]
		}
		return 0
	}
	totalPaymentAmount(){
		let sum = this.payments.reduce((sum, amount) => amount + sum, 0)
		return Math.ceil(Math.ceil(sum * 100) / 100)
	}

	intervalFormatted(){
		return `${this.repeatInterval > 1 ? this.repeatInterval : "" } ${this.intervalLength }${this.repeatInterval > 1 ? "s" : "" }`
	}

	chargeEveryText(){
		return this.installmentsTotal > 1 ? `charged every ${this.intervalFormatted()}` : ""
	}

	paidEveryText(){
		return this.installmentsTotal > 1 ? `paid every ${this.intervalFormatted()}` : ""
	}

	savingsFormatted(currencyItem){
		let savingAmount = Math.floor(this.savingsAmount)
		return savingAmount > 0 ? `save ${currencyItem.formatted(Math.floor(savingAmount))}` : ""
	}

	partialPaymentFormatted(currencyItem){
		if(this.installmentsTotal === 1){
			return `One time payment of ${currencyItem.formatted(this.totalPaymentAmount())}`
		}
		return `${this.installmentsTotal} payments of ${currencyItem.formatted(this.singlePaymentAmount())} (${currencyItem.formatted(this.totalPaymentAmount())} total)`
	}


}
